<template>
  <SectionPanel :greyBg="greyBg" :title="{ value: trackYourPatrolTitle }">
    <template #sectionPanelContent>
      <div class="grid grid-cols-1 w-full gap-6">
        <span class="text-base text-racq-med-grey" v-html="trackYourPatrolDescription"></span>

        <div v-if="showTrackingNumber">
          <label for="tracking-number" class="mb-1 formkit-label block text-input-label w-auto md:pe-8">
            Tracking number
          </label>
          <div class="flex flex-col md:flex-row items-start gap-4">
            <FormKit
              id="tracking-number"
              ref="trackingNumber"
              :modelValue="trackingNumber"
              type="text"
              outerClass="mb-0 sm:w-full md:w-[240px] !opacity-100 text-racq-med-grey"
              name="tracking-number"
              innerClass="w-full !bg-racq-anti-flash-white"
              :disabled="true"
            />
            <button
              type="button"
              class="cta-card-button px-3 py-2 text-base btn-md btn btn-secondary w-full md:w-auto"
              @click.stop.prevent="copyTrackingNumber"
            >
              <img
                :src="buttonIcon"
                :alt="isCopied ? 'success icon' : 'copy icon'"
                role="img"
                class="inline-block h-4 w-4"
              />
              {{ buttonText }}
            </button>
          </div>
        </div>
      </div>

      <div v-if="appDownloadDescription" class="pt-6">
        <p v-html="appDownloadDescription"></p>
      </div>

      <div class="flex flex-row items-center pt-4">
        <template v-if="appleDownloadLink">
          <a :href="appleDownloadLink" target="_blank" class="inline-block mr-4">
            <img src="@/assets/icons/apple-app-store-button.svg" alt="apple app store icon" class="inline-block" />
          </a>
        </template>

        <template v-if="googleDownloadLink">
          <a :href="googleDownloadLink" target="_blank" class="inline-block">
            <img src="@/assets/icons/google-play-store-button.svg" alt="google play store icon" class="inline-block" />
          </a>
        </template>
      </div>

      <div v-if="notes">
        <RichText :field="{ value: notes }" class="text-racq-dark-grey text-base-bold" />
      </div>
    </template>
  </SectionPanel>
</template>
<script setup lang="ts">
import { computed, ref } from 'vue';
import SectionPanel from '@/components/SectionPanel/SectionPanel.vue';
import { RichText, Field } from '@sitecore-jss/sitecore-jss-vue';

const props = defineProps<{
  trackYourPatrolTitle: string;
  trackYourPatrolDescription: string;
  appDownloadDescription: string;
  appleDownloadLink: string;
  googleDownloadLink: string;
  showTrackingNumber: boolean;
  trackingNumber?: string;
  notes?: string;
  greyBg?: Field<boolean | undefined>;
}>();

const localTrackingNumber = ref<string>(props.trackingNumber ?? '');
const buttonText = ref<string>('Copy number');
const isCopied = ref(false);
const buttonIcon = computed(() =>
  isCopied.value
    ? new URL('@/assets/icons/green-success-icon.svg', import.meta.url).href
    : new URL('@/assets/icons/copy-icon.svg', import.meta.url).href
);

const copyTrackingNumber = async () => {
  try {
    await navigator.clipboard.writeText(localTrackingNumber.value);
    buttonText.value = 'Copied';
    isCopied.value = true;
    setTimeout(() => {
      buttonText.value = 'Copy number';
      isCopied.value = false;
    }, 2000);
  } catch (err) {
    console.error('Failed to copy: ', err);
  }
};
</script>
